/* Testimonial strip behaviour (moved out of sections/testimonial.liquid, 3 Oct 2026).
   20 Oct 2026 (Sam): phones get a plain swipe row (class ut-native), desktop unchanged. Undo: git.
   14 Oct 2026 (Sam): prev/next arrows next to the links (each click glides one card, then the strip holds for 4s),
   and trackpad sideways swipes / shift + mouse wheel now move the strip. Previous version: assets/ursa-testimonials.js.before-scroll-arrows-2026-10-14.txt (git tag pre-cleanup-2026-10-19) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var modal = null, modalOpen = false, group = [], gi = 0, suppress = false;

  function stars(s) { return s === '5' ? '★★★★★' : s === '4' ? '★★★★☆' : ''; }

  function getModal() {
    if (modal) return modal;
    modal = document.createElement('dialog');
    modal.className = 'ut-modal';
    modal.setAttribute('aria-label', 'Full review');
    modal.innerHTML = '<div class="ut-modal__card"><button type="button" class="ut-modal__close" aria-label="Close">&times;</button>' +
      '<div class="ut-modal__body"><div class="ut-modal__stars" aria-hidden="true"></div><p class="ut-modal__text"></p></div>' +
      '<div class="ut-modal__foot"><div class="ut-modal__who"><strong></strong><span></span></div>' +
      '<div class="ut-modal__nav"><button type="button" data-ut-prev aria-label="Previous review">&larr;</button><span class="ut-modal__count"></span><button type="button" data-ut-next aria-label="Next review">&rarr;</button></div></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('.ut-modal__close')) { modal.close(); return; }
      if (e.target.closest('[data-ut-prev]')) go(-1);
      else if (e.target.closest('[data-ut-next]')) go(1);
    });
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    });
    modal.addEventListener('close', function () { modalOpen = false; });
    return modal;
  }

  function render(animate) {
    var m = getModal(), c = group[gi];
    var body = m.querySelector('.ut-modal__body');
    function fill() {
      m.querySelector('.ut-modal__stars').textContent = stars(c.getAttribute('data-stars'));
      m.querySelector('.ut-modal__text').innerHTML = c.querySelector('blockquote').innerHTML;
      var who = c.querySelector('figcaption');
      m.querySelector('.ut-modal__who strong').textContent = who.querySelector('strong').textContent;
      var d = who.querySelector('span:not(.ut-quote__more)');
      m.querySelector('.ut-modal__who span').textContent = d ? d.textContent : '';
      m.querySelector('.ut-modal__count').textContent = (gi + 1) + ' / ' + group.length;
      m.querySelector('.ut-modal__text').scrollTop = 0;
      body.classList.remove('is-swap');
    }
    if (animate && !reduce) { body.classList.add('is-swap'); setTimeout(fill, 150); } else fill();
  }
  function go(d) {
    if (group.length < 2) return;
    gi = (gi + d + group.length) % group.length;
    render(true);
  }
  function groupOf(card) {
    var half = card.closest('.ut__half'), seen = {}, out = [];
    Array.prototype.forEach.call(half.querySelectorAll('.ut-quote'), function (c) {
      var i = c.getAttribute('data-i');
      if (!seen[i]) { seen[i] = 1; out.push(c); }
    });
    return out;
  }
  function openCard(card) {
    var m = getModal();
    group = groupOf(card);
    gi = 0;
    group.forEach(function (c, i) { if (c.getAttribute('data-i') === card.getAttribute('data-i')) gi = i; });
    m.querySelector('.ut-modal__nav').style.display = group.length < 2 ? 'none' : '';
    render(false);
    modalOpen = true;
    if (m.showModal) m.showModal(); else m.setAttribute('open', '');
  }

  function init(sec) {
    if (sec.getAttribute('data-ut')) return;
    sec.setAttribute('data-ut', '1');
    var marquee = sec.querySelector('.ut__marquee');
    var track = sec.querySelector('.ut__track');
    var half = sec.querySelector('.ut__half');
    if (!marquee || !track || !half) return;
    // 20 Oct 2026 (Sam): on phones the strip is a normal swipe row (native scrolling, no auto-scroll). The drag-to-move
    // code below could not be moved by a thumb on his iPhone. Desktop keeps the moving strip.
    var native = reduce || window.matchMedia('(max-width: 699px)').matches;
    var glideLeft = 0, holdUntil = 0;
    function now() { return (window.performance && performance.now()) || Date.now(); }
    function hold() { holdUntil = now() + 4000; }
    function step() { var c = half.querySelector('.ut-quote'); return c ? c.getBoundingClientRect().width + 12 : 312; }

    // Write a review link: shown once the Yotpo reviews widget is on the page (it loads late)
    var write = sec.querySelector('[data-ut-write]');
    if (write) {
      var tries = 0;
      var look = function () {
        var widget = document.getElementById('yotpo-reviews-main-widget');
        if (widget) { write.hidden = false; return; }
        if (++tries < 40) setTimeout(look, 500);
      };
      look();
      write.addEventListener('click', function (e) {
        var widget = document.getElementById('yotpo-reviews-main-widget');
        if (!widget) return;
        e.preventDefault();
        widget.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        setTimeout(function () {
          var b = document.getElementById('yotpo-main-widget-btn') || widget.querySelector('.yotpo-new-review-btn');
          if (b) b.click();
        }, reduce ? 50 : 700);
      });
    }

    // Read more cue on clamped cards
    function markClamped() {
      sec.querySelectorAll('.ut-quote').forEach(function (c) {
        var bq = c.querySelector('blockquote');
        if (bq.scrollHeight > bq.clientHeight + 1 && !c.querySelector('.ut-quote__more')) {
          var s = document.createElement('span'); s.className = 'ut-quote__more'; s.textContent = 'Read more';
          c.querySelector('figcaption').appendChild(s);
        }
      });
    }
    markClamped();

    marquee.addEventListener('click', function (e) {
      if (suppress || e.target.closest('a')) return;
      var c = e.target.closest('.ut-quote'); if (c) openCard(c);
    });
    marquee.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var c = e.target.closest('.ut-quote'); if (c) { e.preventDefault(); openCard(c); }
    });

    // Prev / next arrows (14 Oct 2026)
    var head = sec.querySelector('.ut__head');
    if (head && !sec.querySelector('.ut__arrows')) {
      var ar = document.createElement('div');
      ar.className = 'ut__arrows';
      ar.innerHTML = '<button type="button" data-ut-go="-1" aria-label="Previous testimonials"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M12.5 4.5 7 10l5.5 5.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '<button type="button" data-ut-go="1" aria-label="More testimonials"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M7.5 4.5 13 10l-5.5 5.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
      var links = head.querySelector('.ut__links');
      if (links) links.insertBefore(ar, links.firstChild); else head.appendChild(ar);
      ar.addEventListener('click', function (e) {
        var b = e.target.closest('[data-ut-go]'); if (!b) return;
        var d = +b.getAttribute('data-ut-go');
        if (native) { marquee.scrollBy({ left: d * step(), behavior: 'auto' }); return; }
        glideLeft += d * step(); hold();
      });
    }

    if (native) {
      sec.classList.add('ut-native');
      var seenCards = {};
      half.querySelectorAll('.ut-quote').forEach(function (c) {
        var k = c.getAttribute('data-i') + '|' + c.querySelector('blockquote').textContent.slice(0, 60);
        if (seenCards[k]) c.hidden = true; else seenCards[k] = 1;
      });
      return;
    }

    var pos = 0, cur = 38, speed = 38, target = speed, loop = 0, last = 0, onscreen = true, raf = 0;
    var down = false, dragging = false, moved = 0, lastX = 0, lastT = 0, vel = 0;
    sec.classList.add('is-js');
    function measure() { loop = half.getBoundingClientRect().width + 12; }
    function apply() {
      if (loop > 0) pos = ((pos % loop) + loop) % loop;
      track.style.transform = 'translate3d(' + (-pos).toFixed(2) + 'px,0,0)';
    }
    measure();
    window.addEventListener('resize', function () { measure(); markClamped(); });

    // Hover / focus: ease to a stop
    marquee.addEventListener('mouseenter', function () { target = 0; });
    marquee.addEventListener('mouseleave', function () { target = speed; });
    marquee.addEventListener('focusin', function () { target = 0; });
    marquee.addEventListener('focusout', function () { target = speed; });

    // Trackpad sideways swipe, or shift + mouse wheel (14 Oct 2026)
    marquee.addEventListener('wheel', function (e) {
      var dx = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : (e.shiftKey ? e.deltaY : 0);
      if (!dx) return;
      e.preventDefault();
      if (e.deltaMode === 1) dx *= 16;
      glideLeft = 0; cur = 0; pos += dx; apply(); hold();
    }, { passive: false });

    // Drag / swipe with a little momentum
    marquee.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      down = true; moved = 0; lastX = e.clientX; lastT = e.timeStamp; vel = 0;
    });
    marquee.addEventListener('dragstart', function (e) { e.preventDefault(); });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - lastX;
      moved += Math.abs(dx);
      if (!dragging && moved > 6) { dragging = true; marquee.classList.add('is-drag'); cur = 0; glideLeft = 0; }
      if (dragging) {
        var dt = (e.timeStamp - lastT) / 1000 || 0.016;
        vel = vel * 0.7 + (-dx / dt) * 0.3;
        pos -= dx; apply();
      }
      lastX = e.clientX; lastT = e.timeStamp;
    });
    function endDrag() {
      if (!down) return;
      down = false;
      if (dragging) {
        dragging = false; marquee.classList.remove('is-drag');
        suppress = true; setTimeout(function () { suppress = false; }, 80);
        cur = Math.max(-1200, Math.min(1200, vel));
      }
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    // Fade in when scrolled into view, and pause when off screen
    var revealed = false;
    if ('IntersectionObserver' in window) {
      sec.classList.add('ut-fade');
      new IntersectionObserver(function (es) {
        onscreen = es[0].isIntersecting;
        if (onscreen) {
          if (!revealed) { revealed = true; sec.classList.add('is-in'); }
          if (!raf) { last = 0; raf = requestAnimationFrame(tick); }
        }
      }, { rootMargin: '0px 0px -6% 0px' }).observe(sec);
    }

    function tick(t) {
      raf = 0;
      if (!onscreen) return;
      var dt = last ? Math.min((t - last) / 1000, 0.05) : 0;
      last = t;
      if (!dragging) {
        if (glideLeft) {
          var mv = glideLeft * (1 - Math.exp(-dt * 9));
          if (Math.abs(glideLeft - mv) < 0.5) mv = glideLeft;
          pos += mv; glideLeft -= mv; cur = 0;
        } else {
          var goal = (modalOpen || now() < holdUntil) ? 0 : target;
          cur += (goal - cur) * (1 - Math.exp(-dt * 5));
          if (Math.abs(cur) < 0.05 && goal === 0) cur = 0;
          pos += cur * dt;
        }
        apply();
      }
      raf = requestAnimationFrame(tick);
    }
    raf = requestAnimationFrame(tick);
  }

  function boot() { document.querySelectorAll('.ut').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
